import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from "@angular/core";
import {Field} from "../../model/field";

@Component({
  selector: 'gen-field-editor',
  templateUrl: './field-editor.component.html',
  styleUrls: ['./field-editor.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FieldEditorComponent {

  @Input() field: Field;
  @Input() first: boolean;
  @Input() useAnd: boolean;
  @Output() deleteMe = new EventEmitter<Field>();

  constructor() {
  }

  ngOnInit() {
  }

  onClick(): void {
    this.deleteMe.emit(this.field);
  }

  onNegate(): void {
    this.field.negate = !this.field.negate;
  }
}
